import api from "../../../services/apiClient"
import type { AgencyUserFormValues } from "../models/agencyUser"

const BASE = "agency-user"
const INT_BASE = "agency-user-integration"

export const agencyUserApi = {
  getList: async (params?: Record<string, unknown>) => {
    const { data } = await api.get(BASE, { params })
    return data?.data ?? data
  },

  getById: async (id: number) => {
    const { data } = await api.get(`${BASE}/${id}`)
    return data?.data ?? data
  },

  create: async (values: AgencyUserFormValues) => {
    const { data } = await api.post(`${BASE}/create`, values)
    return data?.data ?? data
  },

  update: async (id: number, values: Partial<AgencyUserFormValues>) => {
    const { data } = await api.post(`${BASE}/update/${id}`, values)
    return data?.data ?? data
  },

  delete: async (id: number) => {
    const { data } = await api.delete(`${BASE}/delete/${id}`)
    return data
  },

  activate: async (id: number) => {
    const { data } = await api.post(`${BASE}/activate/${id}`)
    return data?.data ?? data
  },

  deactivate: async (id: number) => {
    const { data } = await api.post(`${BASE}/deactivate/${id}`)
    return data?.data ?? data
  },

  resetPassword: async (id: number, password: string) => {
    const { data } = await api.post(`${BASE}/reset-password/${id}`, {
      password,
    })
    return data?.data ?? data
  },

  getIntegrations: async (userId: number) => {
    const { data } = await api.get(INT_BASE, { params: { user_id: userId } })
    return data?.data ?? data
  },

  deleteIntegration: async (id: number) => {
    const { data } = await api.delete(`${INT_BASE}/delete/${id}`)
    return data
  },

  getCopyableIntegrations: async (userId: number) => {
    const { data } = await api.get(`${INT_BASE}/copy-options/${userId}`)
    return data?.data ?? data
  },

  copyIntegrations: async (userId: number, selection: number[]) => {
    const { data } = await api.post(`${INT_BASE}/copy`, {
      user_id: userId,
      selection,
    })
    return data?.data ?? data
  },

  changeAvatar: async (userId: number, file: File) => {
    const formData = new FormData()
    formData.append("avatar", file)
    const { data } = await api.post(`${BASE}/change-user-image/${userId}`, formData)
    return data?.data ?? data
  },
}
